"use client";

import { CheckText } from "@/components/index/checkText";

export const Top = () => {
	return (
		<div className={"relative"}>
			<div className={"grid gap-4"}>
				<h1
					className={"text-sky-600 font-bold text-3xl md:text-4xl lg:text-4xl"}
				>
					<span className={"whitespace-nowrap"}>高専生向けの</span>
					<span className={"whitespace-nowrap"}>Discordコミュニティ</span>
				</h1>
				<p className={"font-bold"}>
					<span>頑張る高専生を応援するコミュニティです！</span>
					<br />
					<span>このコミュニティを通して、知識を習得し、起業や開発などの</span>
					<br />
					<span>各自の目標を実現していくことを目指します。</span>
				</p>

				<div className={"flex flex-col gap-4"}>
					<div
						className={"bg-stone-100  rounded-md w-full md:w-6/12 lg:w-5/12 "}
					>
						<div className={"p-4 space-y-2 "}>
							<CheckText text={"起業 / 開発をしたい人"} />
							<CheckText text={"何かキッカケが欲しい人"} />
							<CheckText text={"起業を目指す人を応援したい人"} />
						</div>
					</div>
					<button
						type="button"
						className={
							"bg-gradient-to-r from-blue-500 to-green-400 shadow-lg text-white font-bold p-2 rounded-md w-full h-14 md:w-6/12 lg:w-5/12 text-2xl"
						}
						onClick={(): void => {
							window.open(
								"https://docs.google.com/forms/d/1SGyWiaKaSoP00VR0XpAJV8KTz0MYeOcr9HqtsYXVseY/viewform",
							);
						}}
					>
						応募はこちら
					</button>
				</div>
			</div>
			<img
				src={"png/index_bg.png"}
				alt={"index_bg"}
				className={
					"absolute bottom-0 right-0 object-contain w-6/12 -z-10 hidden md:block"
				}
			/>
		</div>
	);
};
